export const SECTION_KEYWORDS = {
  feature: [
    'dependencies',
    'acceptance criteria',
    'description',
    'priority',
    'complexity',
    'user impact'
  ],
  features: [
    'dependencies',
    'acceptance criteria',
    'description',
    'priority',
    'complexity',
    'user impact'
  ],
  'user-role': [
    'description',
    'responsibilities',
    'goals',
    'skills',
    'interactions',
    'performance metrics',
    'relationship to other roles',
    'main workflows'
  ],
  'user-story': [
    'as a',
    'i want',
    'so that',
    'acceptance criteria',
    'priority',
    'related feature',
    'story points',
    'description'
  ],
  integration: [
    'overview',
    'scope of implementation',
    'implementation approaches',
    'approach 1',
    'approach 2',
    'approach 3',
    'approach 4',
    'option 1',
    'option 2',
    'option 3',
    'endpoints',
    'endpoint',
    'api endpoints',
    'api endpoint',
    'configuration',
    'authentication',
    'error handling',
    'rate limiting',
    'documentation',
    'documentation links',
    'implementation',
    'testing',
    'Implementation Steps'
  ],
};

export const getSectionKeywords = (type) => {
  return SECTION_KEYWORDS[type] || SECTION_KEYWORDS['feature'] || [];
};